// SidebarFooter.vue
<template>
  <div class="item" id="footer">
    <!-- Logout Button -->
    <div @click="$emit('logout')" id="logout" class="name">
      {{ $t('logout') }}
    </div>

    <!-- Language Switcher -->
    <Language />

    <!-- Change Club / Participant -->
    <div
      v-if="changeClub"
      @click="$emit('changeClub')"
      class="change_club"
    >
      {{ !event.is_campus ? $t('change_club') : $t('change_participant') }}
    </div>

    <!-- External Link -->
    <a href="http://micsports.es/" target="_blank">
      <div class="item" id="legend">
        <span class="description">{{ $t('organitzation') }}</span>
      </div>
    </a>
  </div>
</template>

<script>
import Language from '@/components/ui/Language.vue'

export default {
  name: 'SidebarFooter',
  components: {
    Language
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    changeClub: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/_left_menu.scss">
/* you can leave this empty or add component-specific overrides */
</style>
